import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import FAQ_LIST from '@/util/FaQData.yaml';
import { Breadcrumb } from '@/components/SBBreadcrumb';

interface FaQData {
    id: string;
    title: string;
    message: string;
}

interface FaQCat {
    category: string;
    list: FaQData[];
}
const LIST: FaQCat[] = FAQ_LIST;

@Component({
    components: AllComponents(),
})
export default class FaQAbout extends Mixins(CommonView) {
    public breadcrumb: Breadcrumb[] = [];
    public title: string = "";
    public message: string = "";

    public created() {
        let id = this.$route.params.id;
        for (const fcat of LIST) {
            for (const faq of fcat.list) {
                if (id === faq.id) {
                    this.title = faq.title;
                    this.message = faq.message;
                    this.breadcrumb = [
                        {
                            title: "FAQ",
                            to: "/faq"
                        },
                        {
                            title: fcat.category
                        },
                    ];
                }
            }
        }
    }

}
